import React from 'react';
import useStyles from './styles'
import {StepperIcon} from "../StepperIcon/StepperIcon";

export default function ResponsiveStepper(props) {
    const classes = useStyles();
    const {className,
        steps,
        activeStep} = props

    return (
        <div className={className}>
            <div className={classes.root}>
                <div className={classes.responsiveStepHeader}>
                    <div className={classes.responsiveStepIcon}>
                        <StepperIcon step={activeStep} id={`MEDCAL_RX_STEPPER_ICON_RESPONSIVE_${activeStep}`} />
                    </div>
                    <div className={classes.responsiveStepTitle}>
                    <span >
                        {steps[activeStep].title}
                    </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
